const NAME = "GENERAL_SETTINGS_PAGE";

export default NAME;
